(() => {
  document.documentElement.classList.add('rb-js');
  const reduce = () => matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* Shipping dates: local calendar days from today */
  function fmtRange(now, start, end, locale) {
    const day = (n) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end)), opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + '–' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = document.documentElement.lang || 'en-US';
    document.querySelectorAll('[data-rb-ship-date]').forEach((el) => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
      el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  window.addEventListener('pageshow', updateShipDates);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateShipDates(); });

  /* Free gift: keep exactly one free gift line while a RUBRA head is in the cart */
  const Gift = (() => {
    let cfg = null, pending = null;
    const base = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    async function req(path, body, tries = 2) {
      const r = await fetch(base() + path, body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); } catch (e) {
        if (tries > 1) { await new Promise((z) => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req('cart.js');
      const isMain = (i) => cfg.mains.includes(Number(i.variant_id));
      const gifts = cart.items.filter((i) => Number(i.variant_id) === cfg.gift);
      const want = cart.items.some(isMain) ? 1 : 0;
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const own = cfg.code.toUpperCase();
      const others = codes.filter((c) => c.toUpperCase() !== own);
      const applied = codes.some((c) => c.toUpperCase() === own);
      const free = gifts.every((i) => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => { updates[g.key] = k === 0 ? want : 0; });
      else if (want) updates[cfg.gift] = want;
      const drawer = document.querySelector('cart-drawer');
      const sections = (drawer && drawer.getSectionsToRender && drawer.getSectionsToRender().map((s) => s.id)) || [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...(want ? [cfg.code] : [])].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter((i) => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (want && charged.length) {
        const rm = {};
        charged.forEach((i) => { rm[i.key] = 0; });
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your RUBRA is in your cart, but the free gift could not be applied. Please contact us before checkout.');
      }
      if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return {
      set(c) { cfg = c; },
      sync() { if (pending) return pending; pending = reconcile().finally(() => { pending = null; }); return pending; }
    };
  })();
  window.RubraGift = Gift;

  /* Section reveal: fade up, headline light switches on */
  function initReveal() {
    const secs = document.querySelectorAll('.rb-s[data-rb-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      secs.forEach((s) => io.observe(s));
    } else secs.forEach((s) => s.classList.add('is-in'));
    const catchUp = () => secs.forEach((s) => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  }

  function init() {
    updateShipDates();
    initReveal();
    const root = document.querySelector('#rubra');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.rb-proof .ceyla-rproof__text').forEach((pEl) => pEl.childNodes.forEach((n) => {
      if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' ';
    }));
    const money = (c) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const tiers = [...root.querySelectorAll('[name="rb-tier"]')];
    const styles = [...root.querySelectorAll('[name="rb-style"]')];
    const hose = root.querySelector('[data-rb-addon="hose"]');
    const hoseRow = root.querySelector('[data-rb-hose-row]');
    let tier = Number(root.dataset.tier) || 2;
    let style = root.dataset.style || 'sq';
    const tierInfo = (t) => {
      const r = tiers.find((x) => x.value === String(t)) || tiers[0];
      return {
        r,
        variant: Number(r.dataset['v' + (style === 'hh' ? 'Hh' : 'Sq')]),
        media: r.dataset['m' + (style === 'hh' ? 'Hh' : 'Sq')],
        available: r.dataset['a' + (style === 'hh' ? 'Hh' : 'Sq')] === 'true',
        price: Number(r.dataset.price),
        compare: Number(r.dataset.compare || 0)
      };
    };
    Gift.set({
      mains: tiers.flatMap((r) => [Number(r.dataset.vSq), Number(r.dataset.vHh)]),
      gift: Number(root.dataset.giftVariant) || 0,
      code: root.dataset.giftCode || 'RUBRAGIFT'
    });

    /* Gallery */
    const g = root.querySelector('[data-rb-gallery]');
    const slides = [...g.querySelectorAll('.rb-slide')];
    const thumbs = [...root.querySelectorAll('.rb-thumb')];
    const smooth = () => (reduce() ? 'auto' : 'smooth');
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const to = (i, instant) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: instant ? 'auto' : smooth() });
    root.querySelectorAll('[data-rb-slide]').forEach((b) => b.addEventListener('click', () => to(Number(b.dataset.rbSlide))));
    const nx = root.querySelector('[data-rb-next]'), pv = root.querySelector('[data-rb-prev]');
    if (nx) nx.addEventListener('click', () => to(idx() + 1));
    if (pv) pv.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx(), ix = root.querySelector('[data-rb-index]');
        if (ix) ix.textContent = String(i + 1);
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
      });
    }, { passive: true });
    g.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); }
    });

    const termsId = root.querySelector('[data-rb-terms-id]');
    const addonTotal = () => (hose && hose.checked && style === 'hh' ? Number(hose.dataset.price) : 0);

    const paint = (fromUser) => {
      const t = tierInfo(tier);
      styles.forEach((r) => { r.checked = r.value === style; r.closest('.rb-style').classList.toggle('is-on', r.checked); });
      tiers.forEach((r) => { r.checked = r.value === String(tier); r.closest('.rb-ritual').classList.toggle('is-on', r.checked); });
      root.classList.toggle('is-hh', style === 'hh');
      if (hoseRow) hoseRow.hidden = style !== 'hh';
      root.querySelector('[data-rb-price]').textContent = money(t.price);
      const c = root.querySelector('[data-rb-compare]'), s = root.querySelector('[data-rb-save]');
      if (t.compare > t.price) {
        c.hidden = false; s.hidden = false;
        c.textContent = money(t.compare);
        s.textContent = 'Save ' + money(t.compare - t.price).replace(/\.00(?=\D*$)/, '');
      } else { c.hidden = true; s.hidden = true; }
      const total = t.price + addonTotal();
      document.querySelectorAll('[data-rb-atc-total]').forEach((el) => { el.textContent = money(total); });
      const sp = document.querySelector('[data-rb-sticky-price]');
      if (sp) sp.textContent = money(total);
      if (termsId && termsId.value !== String(t.variant)) { termsId.value = t.variant; termsId.dispatchEvent(new Event('change', { bubbles: true })); }
      const main = root.querySelector('.rb-atc[data-rb-add]');
      if (main) main.disabled = !t.available;
      document.querySelectorAll('[data-rb-pick-tier]').forEach((b) => {
        const on = String(tier) === b.dataset.rbPickTier, sp2 = b.querySelector('span');
        b.setAttribute('aria-pressed', String(on));
        if (sp2) sp2.textContent = on ? sp2.dataset.on : sp2.dataset.off;
      });
      document.querySelectorAll('[data-rb-kit-hose]').forEach((b) => {
        const on = !!(hose && hose.checked && style === 'hh'), sp2 = b.querySelector('span');
        b.setAttribute('aria-pressed', String(on));
        if (sp2) sp2.textContent = on ? sp2.dataset.on : sp2.dataset.off;
      });
      if (fromUser) {
        root.classList.remove('is-pulse'); void root.offsetWidth; root.classList.add('is-pulse');
        if (t.variant) {
          const u = new URL(location.href);
          u.searchParams.set('variant', t.variant);
          history.replaceState(history.state, '', u);
        }
        if (t.media) {
          const si = slides.findIndex((sl) => sl.dataset.mediaId === t.media);
          if (si >= 0 && root.querySelector('.rb-buy').getBoundingClientRect().top < innerHeight) to(si);
        }
      }
    };
    tiers.forEach((r) => r.addEventListener('change', () => { tier = Number(r.value); paint(true); }));
    styles.forEach((r) => r.addEventListener('change', () => { style = r.value; paint(true); }));
    if (hose) hose.addEventListener('change', () => paint(false));

    const scrollToBuy = () => {
      const el = root.querySelector('.rb-rituals') || root;
      el.scrollIntoView({ behavior: smooth(), block: 'center' });
    };
    document.querySelectorAll('[data-rb-pick-tier]').forEach((b) => b.addEventListener('click', () => {
      tier = Number(b.dataset.rbPickTier) || 2; paint(true); scrollToBuy();
    }));
    document.querySelectorAll('[data-rb-pick-style]').forEach((b) => b.addEventListener('click', () => {
      style = b.dataset.rbPickStyle === 'hh' ? 'hh' : 'sq'; paint(true); scrollToBuy();
    }));
    document.querySelectorAll('[data-rb-kit-hose]').forEach((b) => b.addEventListener('click', () => {
      if (!hose) return;
      if (style !== 'hh') { style = 'hh'; hose.checked = true; }
      else hose.checked = !hose.checked;
      paint(true);
    }));
    paint(false);
    window.addEventListener('pageshow', () => paint(false));

    /* Native cart drawer */
    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = document.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = (n) => root.querySelectorAll('[data-rb-count]').forEach((e) => { e.textContent = n; });
    const vipFirst = () => {
      const sheet = document.querySelector('.vf-root'), bag = document.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach((p) => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => {
        if (sheet.classList.contains('open') || ++ticks >= 15) {
          clearInterval(tm);
          Object.keys(hide).forEach((p) => bag.style.removeProperty(p));
        }
      }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget, t = tierInfo(tier);
      if (!t.available || !t.variant) return;
      busy = true;
      const buttons = [...document.querySelectorAll('[data-rb-add]')];
      buttons.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-rb-error]');
      err.textContent = '';
      try {
        const drawer = await drawerReady();
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map((s) => s.id);
        const items = [{ id: t.variant, quantity: 1 }];
        if (hose && hose.checked && style === 'hh') items.push({ id: Number(hose.dataset.variant), quantity: 1 });
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: location.pathname })
        });
        let data;
        try { data = JSON.parse(await res.text()); } catch (x) { throw Error('Your RUBRA could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your RUBRA could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Gift.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false);
      }
    }
    document.querySelectorAll('[data-rb-add]').forEach((b) => b.addEventListener('click', add));
    root.querySelectorAll('[data-rb-cart]').forEach((b) => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Gift.sync();
        const ids = d.getSectionsToRender().map((s) => s.id);
        const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const [sections, c] = await Promise.all([
          fetch(base + '?sections=' + ids.join(',')).then((r) => r.json()),
          fetch(base + 'cart.js').then((r) => r.json())
        ]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-rb-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__rbSync);
        window.__rbSync = setTimeout(() => Gift.sync().then((c) => c && setCount(c.item_count)).catch((x) => {
          const e = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-rb-error]');
          if (e) e.textContent = x.message;
        }), 150);
      });
    }
    const nd = document.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    document.addEventListener('click', (e) => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.rbReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Gift.sync().then(() => {
        const n = document.querySelector('cart-drawer [name="checkout"]') || b;
        n.dataset.rbReady = '1'; n.click(); delete n.dataset.rbReady;
      }).catch((x) => {
        const el = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-rb-error]');
        if (el) el.textContent = x.message;
      });
    }, true);
    Gift.sync().then((c) => c && setCount(c.item_count)).catch(() => {});

    const dlg = document.querySelector('#rubra-policy');
    if (dlg) {
      document.querySelectorAll('[data-rb-policy]').forEach((b) => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-rb-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
    const cBan = document.querySelector('.rb-banner'), cPill = document.querySelector('.rb-concept-pill');
    if (cPill) {
      if (cBan && 'IntersectionObserver' in window) new IntersectionObserver((es) => cPill.classList.toggle('is-on', !es[0].isIntersecting)).observe(cBan);
      else cPill.classList.add('is-on');
    }
    const sticky = document.querySelector('[data-rb-sticky]'), buy = root.querySelector('.rb-buy .rb-atc');
    if (sticky && buy) {
      let sraf;
      const check = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelector('button').tabIndex = show ? 0 : -1;
        });
      };
      addEventListener('scroll', check, { passive: true });
      addEventListener('resize', check);
      check();
    }
  }

  function widgets() {
    document.querySelectorAll('[data-rb-fit]').forEach((f) => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const tabs = [...f.querySelectorAll('[data-fx]')], ans = [...f.querySelectorAll('[data-fx-ans]')];
      tabs.forEach((b) => b.addEventListener('click', () => {
        tabs.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        ans.forEach((a) => { a.hidden = a.dataset.fxAns !== b.dataset.fx; });
      }));
    });
    document.querySelectorAll('[data-rb-ba]').forEach((w) => {
      if (w.dataset.ready) return;
      w.dataset.ready = '1';
      const r = w.querySelector('[data-rb-ba-range]'), st = w.querySelector('.rb-ba-stage');
      const set = () => { const p = Number(r.value); st.style.setProperty('--p', p + '%'); w.classList.toggle('is-red', p < 50); };
      r.addEventListener('input', set); set();
    });
    document.querySelectorAll('[data-rb-demo]').forEach((d) => {
      if (d.dataset.ready) return;
      d.dataset.ready = '1';
      const v = d.querySelector('[data-rb-valve]'), lab = v.querySelector('b');
      let touched = false;
      const setOn = (on) => {
        d.classList.toggle('is-on', on);
        v.setAttribute('aria-pressed', String(on));
        lab.textContent = on ? lab.dataset.on : lab.dataset.off;
      };
      v.addEventListener('click', () => { touched = true; setOn(!d.classList.contains('is-on')); });
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => es.forEach((e) => {
          if (e.isIntersecting && !touched) { setTimeout(() => { if (!touched) setOn(true); }, reduce() ? 0 : 900); io.disconnect(); }
        }), { threshold: 0.55 });
        io.observe(d);
      }
    });
  }

  const boot = () => { init(); widgets(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => {
    updateShipDates(); widgets();
    document.querySelectorAll('.rb-s[data-rb-reveal]').forEach((s) => s.classList.add('is-in'));
  });
})();
